/*@ngInject*/
const PolicyIssuanceActionUtil = function ($rootScope, coreConstant, submissionConstant, modalUtil, umModalUtil,
                                                          uiPerformanceLoggerConstant, loadingBarHandler,
                                                          policyIssuanceActionsMediator) {

    this.beginIssuance = function (policyIssuanceId) {
        var action = uiPerformanceLoggerConstant.BEGIN_ISSUANCE,
            message = policyIssuanceId.toString(),
            promise;

        function onSuccess() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
        }

        loadingBarHandler.showLoadingBar('submission.policyIssuance.beginIssuance');
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise =  policyIssuanceActionsMediator.beginIssuance(policyIssuanceId).then(onSuccess, onError).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.revertToBound = function (submissionId, policyIssuanceId) {
        function handleClose(result) {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = policyIssuanceActionsMediator.revertToBound(policyIssuanceId, result.reason, result.details).then(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        umModalUtil.showReasonModal(
            submissionId,
            null/*quoteId*/,
            null/*notificationName*/,
            null/*reason*/,
            'submission.wizard.reasonModal.revertToBoundModal',
            false/*isReasonOptional*/,
            uiPerformanceLoggerConstant.REVERT_TO_BOUND,
            handleClose);
    };

    this.submitForIssuance = function (submissionId, policyIssuanceId) {
        function handleClose() {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise =  policyIssuanceActionsMediator.submitForIssuance(policyIssuanceId).then(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        modalUtil.showConfirmationModal(
            submissionId,
            null/*quoteId*/,
            'notification.submitForIssuance',
            'submission.wizard.submitForIssuanceModal',
            uiPerformanceLoggerConstant.SUBMIT_FOR_ISSUANCE,
            /*hideLoadingBar*/false,
            handleClose);
    };

    this.modifyIssuance = function (policyIssuanceId) {
        var action = uiPerformanceLoggerConstant.MODIFY_ISSUANCE,
            message = policyIssuanceId.toString(),
            promise;

        function onSuccess() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
        }

        loadingBarHandler.showLoadingBar('submission.policyIssuance.modifyIssuance');
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = policyIssuanceActionsMediator.modifyIssuance(policyIssuanceId).then(onSuccess, onError).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.markAsIssued = function (submissionId, policyIssuanceId) {
        function handleClose() {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = policyIssuanceActionsMediator.markAsIssued(policyIssuanceId).then(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        modalUtil.showConfirmationModal(
            submissionId,
            null/*quoteId*/,
            'notification.markAsIssued',
            'submission.wizard.markAsIssuedModal',
            uiPerformanceLoggerConstant.MARK_AS_ISSUED,
            /*hideLoadingBar*/false,
            handleClose);
    };

    this.revertToPendingIssuance = function (submissionId, policyIssuanceId) {
        function handleClose(result) {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = policyIssuanceActionsMediator.revertToPendingIssuance(policyIssuanceId, result.reason, result.details).then(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        umModalUtil.showReasonModal(
            submissionId,
            null/*quoteId*/,
            null/*notificationName*/,
            null/*reason*/,
            'submission.wizard.reasonModal.revertToPendingIssuanceModal',
            false/*isReasonOptional*/,
            uiPerformanceLoggerConstant.REVERT_TO_PENDING_ISSUANCE,
            handleClose);
    };
};

angular.module('gw-um-submission')
    .service('policyIssuanceActionUtil', PolicyIssuanceActionUtil);
